
  <change-password
    [form]="form$ | async"
    [hasStarted]="hasStarted"
    [hasFinished]="hasFinished"
    [nonFieldErrors]="nonFieldErrors"
    (changePassword)="changePassword()"
    (toggleConfirm)="toggleConfirm()">
    </change-password>
    